import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService, IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiButtonModule} from '@snelstart/ui-button';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-box3-bank',
    standalone: true,
    imports: [CommonModule, SharedUiButtonModule],
    templateUrl: './tekst-box3-bank.component.html',
    styleUrl: './tekst-box3-bank.component.scss',
})
export class TekstBox3BankComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public focusedElementId: string | null = null;
    public year: number | undefined = 2024;
    public actualYear: number = new Date().getFullYear();
    public vrijstellingBox3 = 0;
    public vrijstellingRegelingen = 0;
    public url = 'https://www.rvo.nl/subsidies-financiering/regeling-groenprojecten';

    constructor(public dataService: BokkzIbDataService) {}

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2024) {
                    this.vrijstellingBox3 = 57000;
                    this.vrijstellingRegelingen = 36952;
                } else if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2025) {
                    this.vrijstellingBox3 = 57684;
                    this.vrijstellingRegelingen = 37395;
                } else if (this.incomeTaxEntity.aangifte?.aangifteJaar === 2026) {
                    this.vrijstellingBox3 = 59357;
                    this.vrijstellingRegelingen = 38479;
                }
                this.year = this.incomeTaxEntity.aangifte?.aangifteJaar;
            }
        });
    }
}
